var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 36,
    viewBox: "0 0 29 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.20508,
    y: 0.732422,
    width: 26.7049,
    height: 34.535,
    rx: 5.5,
    stroke: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5576 12.85C12.6048 12.85 10.8236 13.4186 9.52674 14.344C8.23032 15.2691 7.40762 16.5601 7.40762 18C7.40762 19.4399 8.23032 20.7309 9.52674 21.656C10.8236 22.5814 12.6048 23.15 14.5576 23.15C16.5104 23.15 18.2917 22.5814 19.5885 21.656C20.8849 20.7309 21.7076 19.4399 21.7076 18C21.7076 16.5601 20.8849 15.2691 19.5885 14.344C18.2917 13.4186 16.5104 12.85 14.5576 12.85ZM14.5576 22.1357C12.8478 22.1357 11.3031 21.6623 10.19 20.9054C9.076 20.1479 8.40762 19.1176 8.40762 18C8.40762 16.8824 9.076 15.8521 10.19 15.0946C11.3031 14.3377 12.8478 13.8643 14.5576 13.8643C16.2674 13.8643 17.8122 14.3377 18.9253 15.0946C20.0392 15.8521 20.7076 16.8824 20.7076 18C20.7076 19.1176 20.0392 20.1479 18.9253 20.9054C17.8122 21.6623 16.2674 22.1357 14.5576 22.1357Z",
    fill: "#939AA8",
    stroke: "#939AA8",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5607 14.9926C13.9766 14.9926 13.4058 15.1693 12.9206 15.5002C12.4355 15.8309 12.0578 16.3008 11.8349 16.8499C11.612 17.399 11.5537 18.0031 11.6673 18.5858C11.7809 19.1686 12.0614 19.7043 12.4737 20.125C12.8861 20.5458 13.4118 20.8327 13.9847 20.949C14.5575 21.0652 15.1512 21.0055 15.6907 20.7775C16.23 20.5496 16.6906 20.1637 17.0143 19.6692C17.3381 19.1748 17.5107 18.5938 17.5107 17.9997C17.5107 17.2031 17.2007 16.4386 16.6478 15.8744C16.0948 15.3102 15.3441 14.9926 14.5607 14.9926ZM14.5607 19.9926C14.1758 19.9926 13.7992 19.8761 13.4785 19.6575C13.1579 19.4389 12.9075 19.1278 12.7596 18.7633C12.6116 18.3988 12.5729 17.9975 12.6483 17.6104C12.7238 17.2232 12.91 16.868 13.183 16.5895C13.4559 16.311 13.8032 16.1217 14.1809 16.045C14.5586 15.9684 14.95 16.0077 15.306 16.1581C15.662 16.3086 15.9667 16.5636 16.1813 16.8914C16.396 17.2192 16.5107 17.6049 16.5107 17.9997C16.5107 18.5292 16.3046 19.0364 15.9385 19.41C15.5726 19.7834 15.0769 19.9926 14.5607 19.9926Z",
    fill: "#939AA8",
    stroke: "#939AA8",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/EyeIcon.62029d08388a8d124b79c21cd8d97dc4.svg";
export { ForwardRef as ReactComponent };